<template>
  <div class="coupon-accordion">
    <h3>Have a coupon? <span id="showcoupon">Click here to enter your code</span></h3>
    <div id="checkout_coupon" class="coupon-checkout-content">
      <div class="coupon-info">
        <form action="javascript:void(0)">
          <p class="checkout-coupon">
            <input placeholder="Coupon code" type="text">
            <input class="coupon-inner_btn" value="Apply Coupon" type="submit">
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckoutCoupon"
}
</script>

<style>

</style>
